export default __webpack_public_path__ + "static/media/surprise.14bbbbe1.png";